<template>
    <div id="time-keeping">
        <div class="vx-breadcrumb mb-6">
            <ul class="flex flex-wrap items-center">
                <li class="inline-flex items-end">
                    <router-link to="/after-login"><feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" /></router-link>
                    <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
                </li>
                <li class="inline-flex items-end">
                    <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Time Keeping</span>
                </li>
            </ul>
        </div>

        <!-- <vs-tabs :color="colorx">
            <vs-tab @click="colorx = 'primary'" label="TimeKeepings">
                <div class="con-tab-ejemplo py-4"> -->
                    <time-keeping-component></time-keeping-component>
                <!-- </div>
            </vs-tab>

            <vs-tab @click="colorx = 'primary'" label="Logs">
                <div class="con-tab-ejemplo py-4">
                    <log-component></log-component>
                </div>
            </vs-tab>
        </vs-tabs> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            colorx: 'primary'
        }
    }
}
</script>